<script setup lang="ts">
import './assets/style.scss'
import { VIcons } from '@/shared/ui'
import type { FilterCondition } from '@/widgets/GlobalSearch/model/type.ts'

const selectPresetId = defineModel<number | null>('selectedPreset')
const groups = defineModel<FilterCondition[][]>('groups')

/**
 * Очищаем фильтр и выбранный пресет
 */
const clickHandler = () => {
  selectPresetId.value = null
  groups.value = []
}
</script>

<template>
  <VTooltip location="top" :text="$t('itf.clear_filter')">
    <template #activator="{ props }">
      <VBtn
        color="error"
        variant="tonal"
        :disabled="groups?.length === 0"
        v-bind="props"
        @click="clickHandler"
      >
        <VIcons type="close" />
      </VBtn>
    </template>
  </VTooltip>
</template>
